import styled from "styled-components";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { portalColors } from "./BusinessPortalComponents";

const CountryPhoneInput = styled(PhoneInput)`

    .flag-dropdown {
        background: ${portalColors.surfaceSoft} !important;
        border: 1px solid ${p => p.error ? "#D64545" : portalColors.inputBorder} !important;
        border-radius: var(--calendar-radius-input, 8px) !important;
        height: 40px !important;
        box-shadow: ${portalColors.inputShadow} !important;
    }

    input.form-control {
        color: ${p => p.error > 0 ? "#D64545" : portalColors.text} !important;
        border: 1px solid ${p => p.error ? "#D64545" : portalColors.inputBorder} !important;
        border-radius: var(--calendar-radius-input, 8px) !important;
        height: 40px !important;
        width: 170px !important;
        margin-left: 50px !important;
        padding-left: 20px !important;
        text-align: left !important;
        background-color: ${portalColors.surfaceSoft} !important;
        box-shadow: ${portalColors.inputShadow} !important;
        font-family: Manrope, Helvetica, sans-serif;
        font-weight: 600;

        &::placeholder {
            color: ${portalColors.textSoft};
            font-weight: 500;
        }

        &:focus {
            border-color: ${portalColors.inputBorder} !important;
            box-shadow: ${portalColors.inputShadow} !important;
            background-color: ${portalColors.surfaceTertiary} !important;
        }
    }

    .react-tel-input .selected-flag:focus {
        background-color: unset !important;
    }

    div.flag-dropdown {
        border-radius: var(--calendar-radius-input, 8px);
        border: 1px solid ${portalColors.inputBorder};
        text-align: left;
    }

    div.selected-flag{
        border-radius: var(--calendar-radius-input, 8px) !important;

        &:hover,
        &:focus {
            background: ${portalColors.surfaceTertiary} !important;
        }
    }

    .country-list {
        background: ${portalColors.surface} !important;
        color: ${portalColors.text} !important;
        border: 1px solid ${portalColors.border} !important;
        box-shadow: ${portalColors.shadow} !important;
    }

    .country-list .country:hover,
    .country-list .country.highlight {
        background: ${portalColors.surfaceTertiary} !important;
    }
`;

export default CountryPhoneInput;
